"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultData = void 0;
var defaultData = exports.defaultData = {
  id: 0,
  personnelName: '',
  personnelPhone: '',
  sort: 0
};